import MainSpheronSection from "./MainSpheronSection";

export default MainSpheronSection;
